import {
  GET_INVOICES_FAIL,
  GET_INVOICES_SUCCESS,
  GET_INVOICE_DETAIL_SUCCESS,
  GET_INVOICE_DETAIL_FAIL,
  SEND_INVOICE_FAIL,
  SEND_INVOICE_SUCCESS,
  GET_INVOICE_LIST_SUCCESS,
  GET_INVOICE_LIST_FAIL,
  GET_BULK_BILLINGS_SUCCESS,
  GET_BULK_BILLINGS_FAIL,
  SET_INVOICE_PAGINATION,
} from "./actionTypes";

const INIT_STATE = {
  invoices: [],
  invoiceDetail: [],
  error: [],
  sendRes: [],
  invoiceList: [],
  bulkBills: [],
  pagination: {
    pageIndex: 0,
    pageSize: 20,
    pageCount: 0,
    totalRecords: 0,
  },
};

const Invoices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_INVOICE_PAGINATION:
      return {
        ...state,
        ...(action.payload?.field ? { [action.payload?.field]: action.payload?.value } : {}),
      };
    case GET_BULK_BILLINGS_SUCCESS:
      return {
        ...state,
        bulkBills: action.payload,
      };

    case GET_BULK_BILLINGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        invoiceList: {
          invoice_data: action.payload.invoice_data,
          meta: {
            page: action.payload.pagination.page,
            limit: action.payload.pagination.limit,
            total: action.payload.pagination.total,
            total_pages: action.payload.pagination.total_pages,
          },
        },
      };

    case GET_INVOICE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SEND_INVOICE_SUCCESS:
      return {
        ...state,
        sendRes: action.payload,
      };

    case SEND_INVOICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_INVOICES_SUCCESS:
      return {
        ...state,
        invoices: action.payload,
      };

    case GET_INVOICES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_INVOICE_DETAIL_SUCCESS:
      return {
        ...state,
        invoiceDetail: action.payload,
      };

    case GET_INVOICE_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Invoices;
